import useCourseBuilderContentPermissions from "@src/components/libraryItemDetailPages/course/hooks/useCourseBuilderContentPermissions";
import usePathBuilderContentPermission from "@src/components/libraryItemDetailPages/module/hooks/usePathBuilderContentPermission";
import useSkillBuilderContentPermissions from "@src/components/libraryItemDetailPages/skill/hooks/useSkillBuilderContentPermissions";
import useActionPermissions from "@src/hooks/useActionPermissions";
import useUser from "@src/hooks/useUser";
import { useMemo } from "react";

type BuilderContentPermissions = {
  hasEditPermission: boolean;
};

export const useBuilderContentPermissions = (): BuilderContentPermissions => {
  const user = useUser();
  const { userActionPermissions } = useActionPermissions();
  const skillBuilderPermissions = useSkillBuilderContentPermissions();
  const pathBuilderPermissions = usePathBuilderContentPermission();
  const courseBuilderPermissions = useCourseBuilderContentPermissions();
  const trainingResourceBuilderPermissions =
    user.isStaff ||
    (!skillBuilderPermissions &&
      !pathBuilderPermissions &&
      !courseBuilderPermissions &&
      userActionPermissions?.manageLibrary);
  const hasEditPermission = Boolean(
    pathBuilderPermissions?.hasEditContentPermission ||
      courseBuilderPermissions?.hasEditContentPermission ||
      skillBuilderPermissions?.hasEditContentPermission ||
      trainingResourceBuilderPermissions,
  );
  return useMemo(() => {
    return {
      hasEditPermission,
    };
  }, [hasEditPermission]);
};
